<style>
  .about-us-content {
    width: 100%;
    img{
      width: 100%;
      border: 1px solid #a4a4a4;
      border-radius: 5px;
    }
    p{
      font-size: 15px;
      margin: 15px 0;
      font-weight: 400;
      text-align: justify;
    }
    h2{
      font-size: 22px;
      font-weight: 600;
      margin-bottom: 15px;
    }
    h3{
      font-size: 18px;
    }
    a{
      color: #ff0007;
      font-weight: 500;
    }
    ul{
      padding: 0;
      li{
        padding-left: 20px;
        margin-bottom: 5px;
        position: relative;
        &::before{
          font-family: "Font Awesome 6 Free"; font-weight: 900; content: "\f005";
          font-size: 10px;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          color: #ff0007;
        }
      }
    }
  }
  </style>
  
  <div class="my-profile-details">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="bredcrumbs-opts">
                    <ul>
                        <li>
                          <a href="index.html">
                            {{'Home' | translate}}
                            <i class="fa-solid fa-chevron-right"></i>
                          </a>
                        </li>
                        <li class="active" *ngIf="fAQContent">
                          {{ pageTitle }}
                        </li>
                    </ul>
                </div>
  
                <div class="profile-main-content tab-content">
                    <div *ngIf="fAQContent">
                      <div class="profile-tab-title">
                        <i class="fa-regular fa-circle-question"></i><h4>{{ pageTitle }}</h4>
                      </div>
                      <div class="accordion">
                        <div class="accordion-item" *ngFor="let item of fAQContent; let i = index">
                          <h2 class="accordion-header" (click)="toggleAccordion(i)">
                            {{ item.heading }}
                          </h2>
                          <div class="accordion-collapse collapse" [id]="item.collapseId" [attr.aria-labelledby]="item.headingId"
                               [ngClass]="{ 'show': openAccordionIndex === i }">
                            <div class="accordion-body" [innerHTML]="item.body"></div>
                          </div>
                        </div>
                      </div>                                            
                    </div>
                  </div>
            </div>
        </div>
    </div>
  </div>